/* eslint-disable no-unused-expressions */

import React, { useState } from 'react';
import './style.scss';
import { FormControl, MenuItem, Select } from '@mui/material';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';

/***Component***/
const PaginationComponent = (props) => {
  const [dropdownOpened, setDropdownOpened] = useState(false);
  const pageSizes = props?.pageSizes;
  const shouldRenderItemsPerPage = Array.isArray(pageSizes) && pageSizes?.length > 0;
  const t = props?.t;
  const shouldRenderPageSizes = Array.isArray(pageSizes) && pageSizes.length > 0;
  const pagination = props?.pagination;

  const location = useHistory();

  const setPageQueryString = (page) => {
    let search = window?.location?.search?.split('?page=')[1];
    let item = search?.split('&')[1]?.split('item=')[1];
    location.push({ search: `page=${page}&item=${item}` });
  };

  const handleNext = () => {
    if (!!pagination?.pagesTotalNumber) {
      if (pagination?.currentPage < pagination?.pagesTotalNumber) {
        setPageQueryString(parseInt(pagination?.currentPage) + 1);

        props.setPagination((prev) => {
          return {
            ...prev,
            currentPage: pagination?.currentPage + 1,
            hasPrevious: true,
            hasNext: pagination?.currentPage + 1 < pagination?.pagesTotalNumber,
          };
        });
      }
    }
  };
  const handlePrevious = () => {
    if (!!pagination?.pagesTotalNumber) {
      if (pagination?.currentPage > 1) {
        setPageQueryString(parseInt(pagination?.currentPage) - 1);
        //update count to reload states
        props.setPagination((prev) => {
          return {
            ...prev,
            currentPage: pagination?.currentPage - 1,
            hasNext: true,
            hasPrevious: pagination?.currentPage === 2 ? false : true,
          };
        });
      }
    }
  };
  return (
    shouldRenderPageSizes && (
      <div className="generic-pagination flex-it flex-justify-end">
        <div className="paging-controls flex-it flex-align-item-center">
          <div className="paging-control flex-it flex-align-item-center">
            <div className="text text--font"> {!!t && t('itemsPerPage')}</div>
            <div className={clsx('select', dropdownOpened ? 'open' : '')}>
              <FormControl
                className="form-controle"
                margin="none"
                padding="none"
                sx={{ maxWidth: 63, h: 32, p: 0, m: 0 }}
              >
                <span className="arrow-select-wrap flex-it flex-align-item-center">
                  <img
                    className="arrow-select show-on-open"
                    src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-angledown.svg'}
                  />
                  <img
                    className="arrow-select show-on-close"
                    src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-angledown.svg'}
                  />
                </span>

                <Select
                  onOpen={() => setDropdownOpened(true)}
                  onClose={() => setDropdownOpened(false)}
                  onChange={props?.onChange}
                  variant="standard"
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  defaultValue={pagination?.itemsPerPage}
                  value={pagination?.itemsPerPage}
                >
                  {shouldRenderItemsPerPage &&
                    pageSizes?.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item?.fields?.DropdownValue.value}>
                          {item?.fields?.DropdownText.value}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="paging-control flex-it flex-align-item-center">
            <div className="text text--font"> {!!t && t('Page')}</div>
            <div className="case case--font flex-it flex-align-item-center flex-justify-center">
              {pagination?.currentPage}
            </div>
            {(!!pagination?.pagesTotalNumber && (
              <div className="text text--font flex-it flex-align-item-center">
                {!!t && t('Of')}{' '}
                {pagination?.pagesTotalNumber === 0 ? 1 : pagination?.pagesTotalNumber}
              </div>
            )) || (
              <div className="text text--font flex-it flex-align-item-center">
                {!!t && t('Of')}
                {' 1'}
              </div>
            )}
          </div>
          <div className="paging-control buttons-control flex-it flex-align-item-center">
            <div
              onClick={handlePrevious}
              className={clsx(
                'paging-button case flex-it flex-align-item-center flex-justify-center',
                pagination?.hasPrevious ? '' : 'disabled'
              )}
            >
              <img
                className="arrow-left"
                src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-arrow.svg'}
              />
            </div>
            <div
              onClick={handleNext}
              className={clsx(
                'paging-button case flex-it flex-align-item-center flex-justify-center',
                pagination?.hasNext ? '' : 'disabled'
              )}
            >
              <img
                className="arrow-right"
                src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-arrow.svg'}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default PaginationComponent;
